import { render } from "./AdminBlockedPhones.vue?vue&type=template&id=1e798d1e&scoped=true"
import script from "./AdminBlockedPhones.vue?vue&type=script&lang=js"
export * from "./AdminBlockedPhones.vue?vue&type=script&lang=js"

import "./AdminBlockedPhones.vue?vue&type=style&index=0&id=1e798d1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e798d1e"]])

export default __exports__